import {css} from 'aphrodite';
import React from 'react';

import * as AuditActions from 'audit/AuditActions';
import {EXPORT_AUDIT_LOG_DISPLAY_STRING} from 'audit/AuditConstants';
import ResourcePresenceManager from 'nav/presence/ResourcePresenceManager';
import ResourcePresenceView from 'nav/presence/ResourcePresenceView';
import {CanvasTitleProps} from 'notebook/canvas/CanvasConstants';
import GridTitleNameEditor from 'notebook/canvas/GridTitleNameEditor';
import gridTitleStyles from 'notebook/canvas/gridTitleStyles';
import getTestProps from 'test/lib/cypress/getTestProps';
import {ButtonSize} from 'ui-library/buttons/Button';
import OverflowMenu, {OverflowMenuOption} from 'ui-library/menus/OverflowMenu';

const UNTITLED_DOCUMENT = 'Untitled document';
export const NO_TEMPLATE_COLLECTION = 'No template collection found';

export default function GridTitleContainer({
  fileId,
  updateTitle,
  title,
  source,
  parentApiIdentifier,
  titleDisabled,
}: CanvasTitleProps): JSX.Element {
  const templateCollectionName = source?.name ?? undefined;
  const templateCollectionUrl = source?.url ?? undefined;

  const auditMenuOption: Array<OverflowMenuOption> = parentApiIdentifier
    ? [
        {
          icon: 'audit-trail',
          contents: <span>{EXPORT_AUDIT_LOG_DISPLAY_STRING}</span>,
          onSelect: () => {
            AuditActions.exportAuditLogs([parentApiIdentifier]);
          },
        },
      ]
    : [];

  return (
    <div className={css(gridTitleStyles.gridTitleContainer)}>
      <div className={css(gridTitleStyles.gridTitleInfoContainer)}>
        <div className={css(gridTitleStyles.gridTitleInfo)}>
          {templateCollectionUrl ? (
            <div
              className={css(
                gridTitleStyles.gridTitleTemplateCollectionName,
                gridTitleStyles.withTrailingSlash
              )}
            >
              <a
                href={templateCollectionUrl}
                {...getTestProps({component: 'GridTitleEditor', element: 'gridTitleContainerName'})}
              >
                {templateCollectionName}
              </a>
            </div>
          ) : (
            <div
              className={css(
                gridTitleStyles.gridTitleTemplateCollectionNameNoLink,
                gridTitleStyles.withTrailingSlash
              )}
            >
              {NO_TEMPLATE_COLLECTION}
            </div>
          )}
          <div className={css(gridTitleStyles.gridTitleTemplateName)}>
            <GridTitleNameEditor
              name={title || UNTITLED_DOCUMENT}
              onRename={updateTitle}
              titleDisabled={titleDisabled}
            />
          </div>
        </div>
      </div>

      <div className={css(gridTitleStyles.gridTitleOptions)}>
        <div className={css(gridTitleStyles.resourcePresenceContainer)}>
          <ResourcePresenceManager fileId={fileId}>
            <ResourcePresenceView resourceId={fileId} />
          </ResourcePresenceManager>
        </div>
        <OverflowMenu
          options={[...auditMenuOption]}
          menuProps={{dropLeft: true}}
          buttonProps={{
            size: ButtonSize.MEDIUM,
            dataTestAttrs: {component: 'GridTitleEditor', element: 'overflowMenu'},
          }}
        />
      </div>
    </div>
  );
}
